import React from 'react';
import autobind from 'autobind';
import { observer, inject } from 'mobx-react';
import { observable, makeObservable } from 'mobx';

import { PhoneWidget, PhoneWidgetProps } from './PhoneWidget';
import { AppState } from '@store/App/App';
import { appService } from '@store/App/appService';
import { AuthUser } from '@store/AuthUser/AuthUser';
import { authUserService } from '@store/AuthUser/services/authUserService';
import { SipConfigurationsData } from 'chaika-frontend-types/frontend-cms';

interface Props extends PhoneWidgetProps {}

interface StoreProps {
    authUser: AuthUser;
    app: AppState;
}

const injectableStores: (keyof StoreProps)[] = [AppState.Name, AuthUser.Name];

@observer
export class Component extends React.Component<Props & StoreProps> {
    @observable
    private currentDialString = '';

    @observable
    private isOnLoad = true;

    constructor(props: Props & StoreProps) {
        super(props);
        makeObservable(this);
    }

    public async componentDidMount(): Promise<void> {
        await Promise.all([authUserService.initSipAccount(), appService.loadSipConfig()]);
        this.currentDialString = this.props.app.phoneWidget.initialPhoneNumber ?? '';
        this.isOnLoad = false;
    }

    public render(): React.ReactNode {
        const {
            app: { sip = {} as SipConfigurationsData },
            authUser: { sipAccount = {} },
        } = this.props;
        return React.createElement(PhoneWidget, {
            ...sip,
            ...sipAccount,
            isOnLoad: this.isOnLoad,
            currentDialString: this.currentDialString,
            onDialpadButtonClick: this.handleDialpadButtonClick,
            onDialStringChange: this.handleDialStringChange,
            onStartNewSession: this.handleStartNewSession,
            onSessionTerminated: this.handleSessionTerminated,
        });
    }

    @autobind
    private handleDialStringChange({ target: { value } }: React.ChangeEvent<HTMLInputElement>): void {
        this.currentDialString = value;
    }

    @autobind
    private handleDialpadButtonClick(value: string): void {
        this.currentDialString = `${this.currentDialString}${value}`;
    }

    @autobind
    private handleStartNewSession(): void {
        this.props.app.phoneWidget.hasActiveSession = true;
    }

    @autobind
    private handleSessionTerminated(): void {
        this.props.app.phoneWidget.hasActiveSession = false;
    }
}

export const PhoneWidgetContainer = inject<Props, StoreProps>(...injectableStores)(Component);
